import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OnboardingLayout } from "@layouts/OnboardingLayout";
import { InputComponent } from "@shared/forms";
import { PrimaryButton } from "@shared/buttons";
import Logo from "@shared/Logo";
import {
  requestResetPasswordOTP,
  verifyRestPasswordOTP,
} from "@services/krent.service";
import OtpModal from "@pages/SignUp/OtpModal";
import { toast } from "react-toastify";

export const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showOtpModal, setShowOtpModal] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await requestResetPasswordOTP(email);
      setSuccess(res.message);
      setShowOtpModal(true);
    } catch (err: any) {
      setError(err);
      setTimeout(() => setError(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (otp: string) => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await verifyRestPasswordOTP(email, otp);
      if (res.success) {
        setSuccess(res.message || "OTP verified successfully");
        setShowOtpModal(false);
        navigate("/change-password", { state: { email, code: otp } });
      } else {
        setError(res.message);
        toast.error(res.message || "Failed to Verify Account");
      }
    } catch (err: any) {
      toast.error(err.errors[0].message || "Failed to Verify Account");
      setError("Failed to verify OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <OnboardingLayout>
      <div className="container">
        <h3
          className="text-md-start fw-bolder mb-2 text-link text-black mt-3"
          onClick={() => navigate("/")}
        >
          <Logo />
        </h3>

        <h4 className="fw-bolder">Reset your password</h4>
        <p className="fs-14 mb-4">
          Lost your password? Enter your email address to receive an OTP.
        </p>

        <form className="mt-4 mt-md-3" onSubmit={handleSubmit}>
          <div className="col mb-4">
            {success && <span className="text-success col-12">{success}</span>}
            <InputComponent
              label="Email Address"
              placeholder="Enter your email address"
              icon="Message"
              type="email"
              value={email}
              change={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="col text-center">
            {error && <span className="text-danger mb-1">{error}</span>}
            <PrimaryButton
              type="primary"
              text="Reset Password"
              loading={loading}
            />
          </div>
          <div className="col text-end mb-5">
            <Link className="fs-14 text-link" to="/">
              Back Home
            </Link>
            <Link className="fs-14 text-link ml-3" to="/sign-in">
              Sign In
            </Link>
          </div>
        </form>
      </div>

      <OtpModal
        email={email}
        open={showOtpModal}
        onClose={() => setShowOtpModal(false)}
        loading={loading}
        onVerify={handleVerifyOtp}
        type="reset"
      />
    </OnboardingLayout>
  );
};
